var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientLogo3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 31,
    viewBox: "0 0 100 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.455 29.8805H35.4453L40.4552 0.839844H48.4644L43.455 29.8805Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4915 1.54895C70.9115 0.961319 68.4059 0.3125 65.3076 0.3125C57.3977 0.3125 51.8278 4.26681 51.7936 9.92013C51.7278 14.0912 55.7815 16.4079 58.8134 17.7987C61.9121 19.2199 62.9656 20.1475 62.9656 21.4143C62.934 23.3599 60.4616 24.2566 58.1554 24.2566C54.9576 24.2566 53.2443 23.7942 50.6403 22.7119L49.5858 22.2479L48.4648 28.7668C50.3435 29.5691 53.8045 30.2812 57.3977 30.3125C65.8021 30.3125 71.2735 26.4194 71.3382 20.3948C71.3702 17.0889 69.2297 14.5556 64.615 12.4857C61.8135 11.157 60.098 10.2609 60.098 8.90147C60.1309 7.66544 61.5491 6.39953 64.7115 6.39953C67.3152 6.33752 69.2285 6.92432 70.6778 7.51153L71.4021 7.81997L72.4915 1.54895Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8297 0.839844H93.025L99.4868 29.8801H92.0706C92.0706 29.8801 91.3449 26.5435 91.115 25.5238H80.8312C80.534 26.2958 79.1503 29.8801 79.1503 29.8801H70.7461L82.6433 3.24927C83.4676 1.36462 84.9191 0.839844 86.8297 0.839844ZM86.336 11.4672C86.336 11.4672 83.7978 17.924 83.1382 19.5923H89.7958C89.4664 18.1406 87.9496 11.189 87.9496 11.189L87.3899 8.68686C87.1541 9.33112 86.8133 10.217 86.5833 10.8146C86.4275 11.2195 86.3225 11.4921 86.336 11.4672Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.741213 0.839844H13.6278C15.3747 0.901034 16.792 1.42623 17.2531 3.281L20.0537 16.6241L20.0546 16.6266L20.9116 20.6427L28.7558 0.839844H37.2253L24.6355 29.8498H16.1656L9.02666 4.61598C6.56351 3.26586 3.75237 2.18 0.609375 1.42664L0.741213 0.839844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLogo3);
export default __webpack_public_path__ + "static/media/client-logo-3.1beaee8308f3b0a2af4af4334bca1879.svg";
export { ForwardRef as ReactComponent };